// extracted by mini-css-extract-plugin
export default {"productList":"ProductList_productList__JYEnm","productListItem":"ProductList_productListItem__ddbSV"};